// owner 2026-10-12: SPK Jersey as a worksheet — pure helpers (no imports, tested by Jest).

const tgl = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  return m ? `${m[3]}/${m[2]}/${m[1]}` : "-";
};
export const tanggalLk = tgl;

// planned finish as on the Excel sheet
export const rencanaLk = (d) => {
  if (!d) return "-";
  if (d.rencana_selesai) return `${tgl(d.rencana_selesai)}${d.rencana_selesai_jam ? ` ${d.rencana_selesai_jam}` : ""}${d.layanan === "EXPRESS" ? " · EXPRESS" : ""}`;
  return d.rencana_status === "MENUNGGU_ACC" ? "menunggu ACC" : "belum ditentukan";
};

// "M 2 · L 1" (only sizes ordered)
export const ringkasUkuran = (ukuran) => (ukuran || []).filter((u) => u.jumlah).map((u) => `${u.ukuran} ${u.jumlah}`).join(" · ");

// the parts of a variasi line that are filled, joined like on the sheet
export const gabung = (...xs) => xs.filter((x) => x !== null && x !== undefined && x !== "").join(" · ");

export const kerahLk = (v) => gabung(v?.kerah, v?.kerah_barang) || "-";

// owner 2026-10-15 (TAMBAHAN-OWNER-OKT A7): the Excel download is for Owner, Manager and
// Finance; every other role views the sheet on screen (the server refuses the download too)
// v2.18 B: + Pattern & Layout (the server only lets it download SPKs of its own station)
export const UNDUH_LK = ["admin", "manager", "finance", "pattern_layout"];
export const bolehUnduhLk = (role) => UNDUH_LK.includes(role);

// the sheet on screen has the width of A4 at 96 dpi; a narrower screen shrinks it
export const LEBAR_A4 = 794;
export const skalaA4 = (lebar) => (lebar > 0 ? Math.min(1, lebar / LEBAR_A4) : 1);

// sizes across like the Excel sheet: 6 per row, TOTAL at the end of the last row
export function barisUkuran(ukuran, total, per = 6) {
  const out = [];
  const u = ukuran || [];
  for (let i = 0; i < Math.max(u.length, 1); i += per) {
    const potong = u.slice(i, i + per);
    const akhir = i + per >= u.length;
    out.push({ kepala: [...potong.map((x) => x.ukuran), ...Array(per - potong.length).fill(""), akhir ? "TOTAL" : ""],
      isi: [...potong.map((x) => x.jumlah), ...Array(per - potong.length).fill(""), akhir ? total : ""] });
  }
  return out;
}

// owner 2026-10-15 (A5): the labelled pictures besides the main one
export const slotLain = (mockup) => (mockup?.slot || []).filter((s) => s.versi !== mockup.versi);
export const labelUtama = (mockup) => (mockup?.slot || []).find((s) => s.versi === mockup?.versi)?.label || null;
